import { EventType } from "../types/Types";

export const eventTypeOptions = [
  EventType.LOCATION_OPENING,
  EventType.LOCATION_CLOSING,
  EventType.LOCATION_TEMPORARILY_CLOSING,
  EventType.LOCATION_REOPENING,
];

export const getEventTypeLabel = (type: EventType | ''): string => {
  switch (type) {
    case EventType.LOCATION_OPENING: return 'Pub Opening';
    case EventType.LOCATION_CLOSING: return 'Permanently Closing';
    case EventType.LOCATION_TEMPORARILY_CLOSING: return 'Temporarily Closing';
    case EventType.LOCATION_REOPENING: return 'Pub Reopening';
    case EventType.VISIT: return 'Visit';
    default: return 'Select type';
  }
};

export const getEventBadgeColor = (type: EventType): string => {
  switch (type) {
    case EventType.LOCATION_OPENING: return '#1e7e34';
    case EventType.LOCATION_CLOSING: return '#dc3545';
    case EventType.LOCATION_TEMPORARILY_CLOSING: return '#fd7e14';
    case EventType.LOCATION_REOPENING: return '#c1a702ff';
    default: return '#6c757d';
  }
};
